import { render, staticRenderFns } from "./TeacherImage.vue?vue&type=template&id=13f92be0&"
import script from "./TeacherImage.vue?vue&type=script&lang=js&"
export * from "./TeacherImage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherImage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeacherImage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports